import React from 'react';
import { motion } from 'framer-motion';

function APAlfredLogo({ size = 40 }) {
  // Ajuste de tamaño: un poco más pequeño (0.85) como se solicitó
  const adjustedSize = size * 0.85;

  // Animation variants
  const logoVariants = {
    hover: { scale: 1.05, transition: { duration: 0.3 } },
    tap: { scale: 0.95, transition: { duration: 0.1 } }
  };

  return (
    <motion.div
      className="flex items-center justify-center overflow-hidden"
      style={{ width: adjustedSize, height: adjustedSize }}
      variants={logoVariants}
      whileHover="hover"
      whileTap="tap"
    >
      <img 
        src="https://media-manager-c.questera.ai/greta-media/f59ee8d51e80f1806a948e898bca13b731b922719b7b3cf29b37e0809a0eb997985d6957a8ff2154485671175b200ffd/images/aW1hZ2UvcG5n/8bec908b42c084aefff0ce4e772f4c42.PNG"
        alt="APAlfred Logo"
        className="w-full h-full object-contain drop-shadow-sm"
      />
    </motion.div>
  );
}

export default APAlfredLogo;